import { setShowArchived, setShowDisabled, setShowHidden, setShowInherited } from '@admin-slice';
import { Box, FormControlLabel, FormGroup, Popover, Switch } from '@mui/material';
import { RootState } from '@store';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export interface FilterPopoverProps {
  anchor: null | HTMLElement;
  onClose: () => void;
}
const FilterPopover = ({ anchor, onClose }: FilterPopoverProps) => {
  const dispatch = useDispatch();
  const { showArchived, showInherited, showDisabled, showHidden } = useSelector(
    (state: RootState) => ({
      showArchived: state.admin.showArchived,
      showInherited: state.admin.showInherited,
      showDisabled: state.admin.showDisabled,
      showHidden: state.admin.showHidden
    }),
    shallowEqual
  );
  const onShowHiddenChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setShowHidden(e.target.checked));
    },
    [dispatch]
  );
  const onShowInheritedChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setShowInherited(e.target.checked));
    },
    [dispatch]
  );
  const onShowDisabledChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setShowDisabled(e.target.checked));
    },
    [dispatch]
  );
  const onShowArchivedChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setShowArchived(e.target.checked));
    },
    [dispatch]
  );
  return (
    <Popover
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 2,
          userSelect: 'none'
        }}
      >
        <FormGroup>
          <FormControlLabel control={<Switch onChange={onShowHiddenChanged} checked={showHidden} />} label="Show hidden" />
          <FormControlLabel control={<Switch onChange={onShowInheritedChanged} checked={showInherited} />} label="Show inherited" />
          <FormControlLabel control={<Switch onChange={onShowDisabledChanged} checked={showDisabled} />} label="Show disabled" />
          <FormControlLabel control={<Switch onChange={onShowArchivedChanged} checked={showArchived} />} label="Show archived" />
        </FormGroup>
      </Box>
    </Popover>
  );
};
export default FilterPopover;
